import React from 'react';
import AvatarBadge from './AvatarBadge';
import { SLOT_ANCHORS } from '../../../utils/casinoSeatLayout';

const STATUS_PRIORITY = ['waiting_normal', 'joins_next', 'winner', 'knocked', 'discarded', 'thinking', 'ready', 'voted', 'bot'];

/**
 * Player station around the casino table: avatar + name + chip badge + status.
 */
export default function PlayerStation({
  seatState,
  slot = 'bottom',
  creditValue = 1,
  suitVote = null,
  phase = 'waiting',
  hasFreeHand = false,
  winnerEarnings = 0,
}) {
  const { player, isLocalPlayer, isDealer, statusBadges, visualState, credits, isWinner, isPendingJoin } = seatState;
  const anchor = SLOT_ANCHORS[slot] || SLOT_ANCHORS.top;
  const money = ((credits || 0) * (creditValue || 1)).toFixed(2);
  const showWinner = !!isWinner && (phase === 'results' || phase === 'done' || phase === 'reveal');
  const badges = (statusBadges || [])
    .filter((b) => b !== 'dealer' && b !== 'winner')
    .sort((a, b) => STATUS_PRIORITY.indexOf(a) - STATUS_PRIORITY.indexOf(b))
    .slice(0, 2);

  const badgeLabel = (b) => {
    if (b === 'joins_next') return 'next hand';
    if (b === 'waiting_normal') return 'next round';
    return b;
  };

  const suitSymbols = { spades: '♠', hearts: '♥', diamonds: '♦', clubs: '♣' };

  return (
    <div
      className={[
        'cv2-seat',
        `cv2-seat-slot--${slot}`,
        isLocalPlayer ? 'is-local' : '',
        visualState?.isActive ? 'is-active' : '',
        visualState?.isDimmed ? 'is-dimmed' : '',
        showWinner ? 'is-winner' : '',
        isPendingJoin ? 'is-pending' : '',
      ].filter(Boolean).join(' ')}
      style={{ left: `${anchor.left}%`, top: `${anchor.top}%` }}
    >
      {showWinner && (
        <div className="cv2-winner-tag">
          Winner{winnerEarnings > 0 ? ` +${winnerEarnings}` : ''}
        </div>
      )}
      <AvatarBadge
        name={player.name}
        avatarUrl={player.avatarUrl}
        isLocal={isLocalPlayer}
        isActive={!!visualState?.isActive || showWinner}
        isDealer={!!visualState?.showDealerButton || isDealer}
        ready={(statusBadges || []).includes('ready')}
      />
      <div className="cv2-nameplate">
        <div className="cv2-name">
          {player.name}{player.isBot ? ' · bot' : ''}
        </div>
        <div className="cv2-chip-badge" title="Balance">
          <span aria-hidden="true">●</span>
          ${money}
        </div>
      </div>
      {badges.length > 0 && (
        <div className="cv2-status-row">
          {badges.map((b) => (
            <span key={b} className={`cv2-status ${b}`}>{badgeLabel(b)}</span>
          ))}
        </div>
      )}
      {phase === 'suitvote' && suitVote && !isPendingJoin && (
        <div className="cv2-status">Suit {suitSymbols[suitVote] || suitVote}</div>
      )}
      {hasFreeHand && !isPendingJoin && <div className="cv2-status knocked">Free hand</div>}
    </div>
  );
}
